module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_1-c14bffbae8ff0d3806bdf675972782fc.webp";